import React, { useState } from "react";
import Theme from "../UI/Theme";
import UseWindowWidth from "../UI/CustomHooks/UseWindowWidth";
import { CashBackCarouselOptions } from "./CashBack";
import { CashForACauseCards } from "./CashForACause";
import { Container, Row } from "react-bootstrap";
import { rewardsOverviewText } from "../../settings/Constants";
import styled, { css } from "styled-components";
import { rem } from "polished";

const StyledContainer = styled(Container)`
  font-family: ${({ theme }) => theme.secondaryFont};
`;

const StyledRow = styled(Row)`
  display: block;
  max-width: 950px;
  margin: 0 auto !important;
`;

const NavBar = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  border-bottom: ${rem("1px")} solid #9f9f9f;
  margin: ${rem("43px")} ${rem("0px")} ${rem("39px")};
`;

const MenuItem = styled.span`
  cursor: pointer;
  font-size: ${rem("18px")};
  font-weight: 500;
  color: #9f9f9f;
  margin-left: ${rem("10px")};
  margin-right: ${rem("10px")};
  padding-bottom: ${rem("13px")};
  user-select: none;

  ${({ active }) =>
    active &&
    css`
      color: #343638;
      border-bottom: ${rem("2px")} solid #343638;
    `}
`;

const StyledCashBackContainer = styled.div`
  position: relative;
  top: -${rem("40px")};
`;

const CashBack = ({ redemptionArray }) => {
  return (
    <StyledCashBackContainer>
      {/* <Banner 
      backgroundImg={rewardsOverviewText.cashbackSection.bannerImg}
      title={rewardsOverviewText.cashbackSection.title}
      subtitle={rewardsOverviewText.nonInstayCards[0].description}
      coloredTiles={false}
    /> */}
      <CashBackCarouselOptions redemptionArray={redemptionArray} />
    </StyledCashBackContainer>
  );
};

const CashForACause = ({ isMobileView }) => {
  return (
    <>
      {/* <Banner 
      backgroundImg={rewardsOverviewText.cashForACauseSection.bannerImg} 
      title={rewardsOverviewText.cashForACauseSection.title} 
      subtitle={rewardsOverviewText.nonInstayCards[1].description}
      coloredTiles={false}
    /> */}
      <CashForACauseCards isMobileView={isMobileView} />
    </>
  );
};

const PlatformRewardsOverview = ({
  redemptionOptions,
  singleRedemptionOptions,
}) => {
  const [page, setPage] = useState("CASH BACK");

  const navItems = rewardsOverviewText.navWithOnlyCBAndDonation;
  const mobileView = UseWindowWidth() <= 768 ? true : false;

  const redemptionArray = mobileView
    ? singleRedemptionOptions
    : redemptionOptions;

  const MainPageContent = (selectedPage) => {
    switch (selectedPage) {
      case "CASH BACK":
        return <CashBack redemptionArray={redemptionArray} />;
      case "CASH FOR A CAUSE":
        return <CashForACause isMobileView={mobileView} />;
      default:
        return <CashBack redemptionArray={redemptionArray} />;
    }
  };

  return (
    <Theme>
      <StyledContainer fluid>
        <StyledRow>
          <NavBar>
            {navItems.map((menuItem) => (
              <MenuItem
                key={menuItem}
                active={menuItem === page}
                onClick={() => setPage(menuItem)}
              >
                {menuItem}
              </MenuItem>
            ))}
          </NavBar>
          <div>{MainPageContent(page)}</div>
        </StyledRow>
      </StyledContainer>
    </Theme>
  );
};

PlatformRewardsOverview.propTypes = {
  // redemptionOptions: PropTypes.array.isRequired
};

export default PlatformRewardsOverview;
